import * as types from '@/store/types';

const billingInformationModule = {
    state: {
        valid: false,
    },
    mutations: {
        [types.BILLING_INFORMATION__MUTATE_PAYMENT_DETAILS_VALIDATION](localState, validStatus) {
            // eslint-disable-next-line no-param-reassign
            localState.valid = validStatus;
        },
    },

    actions: {
        [types.BILLING_INFORMATION__UPDATE_PAYMENT_DETAILS_VALIDATION]({ commit }, payload) {
            commit(types.BILLING_INFORMATION__MUTATE_PAYMENT_DETAILS_VALIDATION, payload);
        },
        [types.BILLING_INFORMATION__UPDATE_LEAD_SOURCE]({ dispatch }, payload) {
            dispatch(types.ORDER__UPDATE_ORDER, payload);
        },
    },
};

export default billingInformationModule;
